import { config } from '@/configs/configPortal';
import { getVersionSlugged } from '@/helpers/utils';
import { ResultButtonsProps } from '@/interfaces/result';
import './result-buttons.scss';

export function ResultButtons({ type, state, brand, model, version, year }: ResultButtonsProps) {
    const currentUrl = config.urlWebApp;

    let offersUrl;
    if (type === 'carros') {
        offersUrl = `${currentUrl}${type}/${state}/${brand}/${model}/${getVersionSlugged(version)}/de.${year}?tipoveiculo=${type}&marca1=${brand}&modelo1=${model}&versao1=${getVersionSlugged(version)}&anode=${year}&page=1`;
    } else {
        offersUrl = `${currentUrl}${type}/${state}/${brand}/${model}/de.${year}?tipoveiculo=${type}&marca1=${brand}&modelo1=${model}&anode=${year}&page=1`;
    }

    return (
        <div className="result-buttons__container" data-testid="result-buttons-container" id="result-buttons-container">
            <p data-testid="result-buttons-text"> Deseja vender {type === 'carros' ? `este carro` : 'esta moto'} ou ver ofertas similares?</p>
            <div className="result-buttons" data-testid="result-buttons">
                <a
                    target="_blank"
                    href={type === 'carros' ? `${currentUrl}vender-carro` : `${currentUrl}vender-moto`}
                    className="btn btn__default"
                    data-testid="sell-button"
                    id="sell-button"
                >
                    Vender {type === 'carros' ? 'meu carro' : 'minha moto'}
                </a>
                <a
                    href={offersUrl}
                    className="btn btn__secondary"
                    target="_blank"
                    data-testid="offers-button"
                    id="offers-button"
                >
                    Ver ofertas
                </a>
            </div>
        </div>
    );
}